// react, react-dom, redux, react-redux, redux-thunk
import React from 'react';
import ReactDOM from 'react-dom';
import { createStore, applyMiddleware, compose } from "redux";
import { Provider } from "react-redux";
import thunk from "redux-thunk";

// reducers
import reducers from "./reducers";

// app
import App from "./components/App";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose; // redux dev tools
const store = createStore(reducers, composeEnhancers(applyMiddleware(thunk)));


const rootElement = document.getElementById("hero-app");

ReactDOM.render(
  <Provider store={store}>
    <App 
        form={rootElement.getAttribute('data-form')} 
        values={JSON.parse(rootElement.getAttribute('data-form-values'))} 
    />
  </Provider>,
  rootElement
);